export enum ShapeType {
    NoShape,
    Line,
    Dot,
    Circle,
    Ellipse,
    Rectangle,
    TextBox,
    Path,
    PolyLine,
    Image,
    Square
}

export enum ToolType {
    Pointer,
    Move,
    Rotate,
    SelectArea,
    Flipvertical,
    Fliphorizontal
}

export enum State {
    None,
    Moving,
    Finished

}